import type { InstitutionColors } from "@/connect/types";
import { getBankTheme } from "@/lib/bank-theme";
import { motion } from "framer-motion";
import { Building2 } from "lucide-react";

interface InstitutionHeaderProps {
  colors?: InstitutionColors | null;
}

/**
 * Bank/institution header icon displayed above page titles.
 * Shows a Building2 icon in the institution's brand color.
 */
export const InstitutionHeader: React.FC<InstitutionHeaderProps> = ({
  colors,
}) => {
  const theme = getBankTheme(colors);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm"
      style={{
        backgroundColor: theme.primary,
        color: theme.primaryForeground,
      }}
    >
      <Building2 className="h-7 w-7" />
    </motion.div>
  );
};

export default InstitutionHeader;
